import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const TicketIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22 8.00002C22 6.34317 20.6569 5 19 5H5C3.34315 5 2 6.34317 2 8.00002C2 8.95776 2 9.81871 2 10H2.893C3.889 10 4.813 10.681 4.973 11.664C5.02192 11.9511 5.00757 12.2453 4.93094 12.5263C4.85431 12.8072 4.71726 13.068 4.52936 13.2905C4.34147 13.513 4.10725 13.6917 3.84309 13.8143C3.57893 13.9368 3.2912 14.0002 3 14H2C2 14.1813 2 15.0422 2 16C2 17.6568 3.34315 19 5 19H19C20.6569 19 22 17.6568 22 16C22 15.0422 22 14.1813 22 14H21C20.7088 14.0002 20.4211 13.9368 20.1569 13.8143C19.8927 13.6917 19.6585 13.513 19.4706 13.2905C19.2827 13.068 19.1457 12.8072 19.0691 12.5263C18.9924 12.2453 18.9781 11.9511 19.027 11.664C19.187 10.681 20.111 10 21.107 10H22C22 9.81871 22 8.95776 22 8.00002ZM11 17H9V15H11V17ZM11 13H9V11H11V13ZM11 9H9V7H11V9Z"
      fill={color}
    />
  </svg>
);
